import React from "react";
import "./About.scss";
import NavBar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const About = () => {
	return (
		<main className="container justify-between is-flex-direction-column">
			<NavBar active="about" />
			<section className="about">
				<div>
					<h1 class="title-about-me">
						Hello, <span>World!</span>
					</h1>
					<h2 class="subtitle-about-me">
						My name is Steve and i'm just a kid who likes to do things.
						<br></br>I like to do things that haven't been done before and
						<br></br>fail terribly at doing that every time I try!
					</h2>
				</div>
			</section>
			<Footer />
		</main>
	);
};

export default About;
